import { useEffect, useState } from 'react';
import { 
    Create, 
    SimpleForm, 
    TextInput, 
    required, 
    SelectInput, 
    useDataProvider, 
    DateInput, 
    TopToolbar 
} from 'react-admin';
import BackButton from '../../Components/BackButton';
import { useFormContext } from "react-hook-form";

// 添加电话号码校验
const validatePhone = (value: string) => {
    const phoneRegex = /^1[3-9]\d{9}$/;
    if (!phoneRegex.test(value)) {
        return '请输入有效的手机号码';
    }
    return undefined;
};

const validateCashRevenueShare = (value: string) => {
    const numValue = parseFloat(value);

    if (isNaN(numValue)) {
        return '请输入有效的数字';
    }

    if (numValue < 0) {
        return '分成占比不能为负数';
    }

    if (numValue > 100) {
        return '分成占比不能超过100%';
    }

    return undefined;
};

const ActionsToolbar = () => (
    <TopToolbar sx={{ justifyContent: 'start' }}>
        <BackButton />
    </TopToolbar>
);

// 创建商铺选择组件
const ShopSelectInput = ({ mallMerchant }) => {
    const { setValue, watch } = useFormContext();
    const handleShopChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        const shopId = event.target.value as string;
        setValue('mallMerchantId', shopId); // 设置 id 字段的值
    };

    return (
        <>
            <SelectInput
                label="商铺名称"
                source="id"
                choices={mallMerchant}
                optionText="name"
                optionValue="id"
                validate={[required()]}
                onChange={handleShopChange}
            />
            <TextInput 
                label="客户ID" 
                source="mallMerchantId" 
                disabled 
                validate={[required()]} 
            />
        </>
    );
};

export const DeviceAccountCreate = () => {
    const dataProvider = useDataProvider();
    const [customerTypeChoices, setCustomerTypeChoices] = useState([]);
    const [mallMerchant, setMallMerchant] = useState([]);

    useEffect(() => {
        // 异步获取客户类型数据
        const fetchCustomerTypes = async () => {
            try {
                const types = await dataProvider.getCustomerTypes();
                setCustomerTypeChoices(types);
            } catch (error) {
                console.error("获取客户类型失败:", error);
            }
        };

        const getMallMerchant = async () => {
            try {
                const res = await dataProvider.getMallMerchant();
                setMallMerchant(res);
            } catch (error) {
                console.error("获取商城销售商失败:", error);
            }
        };

        getMallMerchant();
        fetchCustomerTypes();
    }, []);

    const transformData = (data: any) => {
        return {
            ...data,
        };
    };

    return (
        <Create actions={<ActionsToolbar />} transform={transformData}>
            <SimpleForm 
                sx={{ width: { lg: '40%', xs: '100%' } }} 
                defaultValues={{ customerType: '2' }}
            >
                <ShopSelectInput mallMerchant={mallMerchant} />
                <TextInput label="客户名称" source="name" validate={[required()]} />
                <SelectInput
                    alwaysOn
                    source="customerTypeId"
                    label="客户类型"
                    choices={customerTypeChoices}
                />
                <TextInput label="分成占比%" source="cashRevenueShare" validate={[required(), validateCashRevenueShare]} />
                <TextInput label="负责人" source="manager" validate={[required()]} />
                <TextInput label="联系电话" source="contactPhone" validate={[required(), validatePhone]} />
                <DateInput
                    label="合同结束日期"
                    source="contractEndDate"
                    validate={[required()]}
                />
            </SimpleForm>
        </Create>
    );
};